import { render } from "./ProductsPage.vue?vue&type=template&id=83331ad8&ts=true"
import script from "./ProductsPage.vue?vue&type=script&lang=ts"
export * from "./ProductsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__